import { useState } from "react";
import { toast } from "react-toastify";
import { validateFields } from "Pages/LIS/Toxicology/CommonFunctions";
import { SaveRunCreation } from "Services/NGSRunCreation";
import LoadButton from "Shared/Common/LoadButton";
import PermissionComponent, {
  getPermissionDisplayName,
} from "Shared/Common/Permissions/PermissionComponent";
import useLang from "Shared/hooks/useLanguage";

function Expand({
  row,
  loadGridData,
  handleChange,
  queryDisplayTagNames,
}: any) {
  const { t } = useLang();

  const [disableSaveBbutton, setDisableSaveBbutton] = useState(false);

  const handlesave = async () => {
    const { isValid, invalidField } = validateFields({
      projectId: row?.projectId,
      runId: row?.runId,
    });

    if (isValid) {
      const payload = {
        id: row.id,
        runName: row.runName,
        runDate: row.id === 0 ? new Date().toISOString() : row.runDate,
        runId: row.runId,
        projectId: row.projectId,
        notes: row.notes,
      };

      setDisableSaveBbutton(true);
      const res = await SaveRunCreation(payload);
      if (res?.data?.statusCode === 200) {
        setDisableSaveBbutton(false);
        loadGridData();
        toast.success(res?.data?.message);
      } else {
        toast.error(res?.data?.message || "Something went wrong.");
      }
    } else {
      const errorMessage = invalidField
        ? `Please Fill ${queryDisplayTagNames[invalidField] ?? ""} field`
        : "Invalid field found";
      toast.error(errorMessage);
    }
  };

  return (
    <>
      <div className="mb-2">
        <span className="fw-bolder" style={{ fontSize: "12px" }}>
          Run Details
        </span>
      </div>
      <div className="card rounded" style={{ border: "2px solid orange" }}>
        <div className="card-header px-4 d-flex justify-content-between align-items-center rounded bg-light-warning min-h-40px">
          <h6 className="mb-0" style={{ color: "orange" }}>
            {"Plate Details"}
          </h6>
        </div>
        <div className="p-4">
          <div className="row mb-2">
            <div className="col-6">
              <span className="fw-bold required">{t("Project ID")}</span>
              <div className="w-100">
                <input
                  id="NGSRunCreationProjectId"
                  type="text"
                  name="projectId"
                  className="form-control bg-white mb-3 mb-lg-0 rounded-2 h-30px fs-8 w-100"
                  placeholder={t("Search...")}
                  value={row.projectId}
                  onChange={(e) =>
                    handleChange(e.target.name, e.target.value, row.id)
                  }
                />
              </div>
            </div>

            <div className="col-6">
              <span className="fw-bold required">{t("Run ID")}</span>
              <div className="w-100">
                <input
                  id="NGSRunCreationRunId"
                  type="text"
                  name="runId"
                  className="form-control bg-white mb-3 mb-lg-0 rounded-2 h-30px fs-8 w-100"
                  placeholder={t("Search...")}
                  value={row.runId}
                  onChange={(e) =>
                    handleChange(e.target.name, e.target.value, row.id)
                  }
                />
              </div>
            </div>
          </div>
          <div className="col-12 mb-4">
            <label htmlFor="ResultDataExpandInternalNotes" className="fw-bold">
              {t("Internal Notes:")}
            </label>
            <textarea
              id="NGSRunCreationNotes"
              className="form-control  h-80px mt-2"
              name="notes" // Name attribute for the text box
              placeholder={t("Notes...")}
              rows={5} // Increase the number of rows to increase the height
              value={row.notes}
              onChange={(e) =>
                handleChange(e.target.name, e.target.value, row.id)
              }
            />
          </div>
          <PermissionComponent
            moduleName="NGS LIS"
            pageName="View Run"
            permissionIdentifier="MovetoCompleted"
          >
            {({ pageName, moduleName, permissionIdentifier }) => (
              <LoadButton
                id={`BloodResultDataExpandValiDate`}
                className="btn btn-primary btn-sm fw-bold search d-block fs-12px h-30px py-0 fw-500"
                loading={disableSaveBbutton}
                btnText={getPermissionDisplayName(
                  pageName,
                  moduleName,
                  permissionIdentifier,
                  "Move to Completed"
                )}
                loadingText={t("Moving.....")}
                onClick={async () => {
                  await handlesave();
                }}
              />
            )}
          </PermissionComponent>
        </div>
      </div>
    </>
  );
}

export default Expand;
